import { render } from "./TheScoreItem.vue?vue&type=template&id=38ab6ea6&ts=true"
import script from "./TheScoreItem.vue?vue&type=script&lang=ts"
export * from "./TheScoreItem.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__